module.exports = __webpack_public_path__ + "img/fa-1@3x.4839f538.png";